import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import { Box, Drawer, Typography, Avatar } from '@mui/material';

import useResponsive from '../../../hooks/useResponsive';
import Scrollbar from '../../../components/scrollbar';
import { NavSection } from '../../../components/nav-section';
import NavConfig from './config';

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const allowedNavConfigs = NavConfig();
  const isDesktop = useResponsive('up', 'lg');
  const navigate = useNavigate();

  useEffect(() => {
    onCloseNav();
  }, [pathname, onCloseNav]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
        bgcolor: (theme) => (theme.palette.mode === 'light' ? "#bad8d9" : ''),
        backgroundImage: (theme) =>
          `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
            theme.palette.primary.dark,
            0.24
          )} 100%)`,
      }}
    >
      <Box sx={{ mb: 5, mt: 5, mx: 2.5 }}>
        <StyledAccount onClick={() => navigate('/landing')} sx={{
          cursor: 'pointer', 
          bgcolor: (theme) => (theme.palette.mode === 'light' ? '#cee8e9' : ''),
          backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(theme.palette.primary.lighter, 0)} 0%, ${alpha(
              theme.palette.primary.light,
              0.24
            )} 100%)`,
        }}>
          <Avatar src="/assets/logo/eotc-logo.png" alt="photoURL" />
          <Box sx={{ ml: 2 }}>
            <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
              አቡቀለምሲስ
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              የሰ/ሸ/ሃ/መ/አ/ስርዓት
            </Typography>
          </Box>
        </StyledAccount>
      </Box>
      <NavSection allowedNavConfigs={allowedNavConfigs} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: { xs: '70%', sm: NAV_WIDTH } },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};
